var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"dxp-card-widget",style:(_setup.cssVarsToStyleString({
		'--pcw-grid-areas--mobile': _setup.mobileGridAreas,
		'--pcw-grid-areas--tablet': _setup.tabletGridAreas,
		'--pcw-grid-areas--desktop': _setup.desktopGridAreas,
	}))},[_c('h2',{staticClass:"visually-hidden"},[_vm._v("Featured Items")]),_vm._v(" "),_c('ul',{staticClass:"dxp-card-widget__card-container",attrs:{"role":"list"}},_vm._l((_vm.widget.data),function(item,i){return _c(_setup.Card,{key:`card-${i}`,style:({ gridArea: 'c' + i }),attrs:{"item":item,"index":i,"widgetId":_vm.widget.widget.id}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }